import {elGR, enUS} from '@mui/x-data-grid-premium/locales';
import {elGR as pickersElGr, enUS as pickersEnUs} from '@mui/x-date-pickers-pro/locales';

export const muiGridLocales = (language) => (
    language === 'el' ? elGR?.components?.MuiDataGrid?.defaultProps?.localeText : enUS?.components?.MuiDataGrid?.defaultProps?.localeText
)

export const muiDatePickersLocales = (language) => (
    language === 'el' ? pickersElGr?.components?.MuiLocalizationProvider?.defaultProps?.localeText : pickersEnUs?.components?.MuiLocalizationProvider?.defaultProps?.localeText
)